// Canvas polyfill for browser environment
// This file provides a basic implementation of the Node.js canvas module for browser use

class CanvasPolyfill {
  constructor(width, height) {
    this.width = width || 0
    this.height = height || 0
    this.canvas = document.createElement('canvas')
    this.canvas.width = this.width
    this.canvas.height = this.height
    this.context = this.canvas.getContext('2d')
  }

  getContext(type) {
    return this.context
  }

  toBuffer() {
    // Convert canvas to buffer-like object
    return this.canvas.toDataURL()
  }

  toDataURL() {
    return this.canvas.toDataURL()
  }
}

// Export the polyfill
export function createCanvas(width, height) {
  return new CanvasPolyfill(width, height)
}

// Mock the Node.js canvas module
const canvasModule = {
  createCanvas,
  Canvas: CanvasPolyfill,
}

// Make it available globally for require calls
if (typeof window !== 'undefined') {
  window.require = window.require || {}
  window.require['canvas'] = canvasModule
}

export default canvasModule
